import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import './firebase.ts'

import App from './App.tsx'
import './index.css'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  // Report from built/deployed apps only — skip the local vite dev server.
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration()],
  // `release` is injected automatically by @sentry/vite-plugin at build time,
  // so it stays in sync with the uploaded source maps.
  tracesSampleRate: 0.1,
})

createRoot(document.getElementById('root')!).render(<App />)
